import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ListItem from 'theme/ListItem';
import Divider from 'theme/Divider';
import { useNavigation, useRoute } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import { setData } from "services/redux/data/actions";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import _ from "lodash";
import { styles } from "./_styles"
import Button from "theme/Button"
import i18n from "utils/i18n";
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedList from 'components/atoms/ThemedList'
import FooterBar from 'components/organisms/FooterBar'
import { FooterStyles } from 'styles/components/organisms/Footer'
import ThemedInputSearch from 'components/atoms/ThemedInputSearch'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import VStack from 'components/atoms/stack/VStack'
import { ThemedValues } from 'styles/themed'

const HomeCoworkerFilterSelectionScene = () => {
	
	const route = useRoute();
	const navigation = useNavigation();
	const dispatch = useDispatch()
	const layoutRef = useRef( undefined )
	
	const _selectedFilterOptions = useSelector( state => {
		return state.data[dataConstants.SELECTED_FILTER_OPTIONS];
	} )
	
	const identifier = _.get( route.params, 'identifier', '??' );
	const title = _.get( route.params, 'title', '??' );
	const options = _.get( route.params, 'options', [] );
	
	const [ loading, setLoading ] = useState( true )
	const [ filter, setFilter ] = useState('')
	const [ activeOptions, setActiveOptions ] = useState( _.get( _selectedFilterOptions, identifier, [] ) )
	
	const filterChanged = ( value ) => {
		setFilter( value?.toLowerCase() ?? '' )
	}
	
	const renderItem = ({ item, index }) => {
		const checked = itemIsChecked( item.guids )

		return (
			<ListItem
				title={ item.title }
				accessoryLeft={ <Icon icon={ IconSystemConstants.CHECKBOX} checked={ checked } /> }
				style={ styles.listItem }
				onPress={ toggleActive.bind( this, item.guids, checked ) }
			/>
		)
	}
	
	const applyFilterOptions = () => {
		let options = _.clone( _selectedFilterOptions )
		if( typeof options !== 'object' ){
			options = {};
		}
		
		options[ identifier ] = activeOptions;
		console.log('testy5', activeOptions, identifier, options );
		
		dispatch( setData( dataConstants.SELECTED_FILTER_OPTIONS, options ) )
		
		navigation.goBack();
	}
	
	const removeActive = () => {
		setActiveOptions( [] )
	}
	
	const toggleActive = useCallback( ( guids, checked ) => {
		let options = []
		
		// When checked -> remove
		if( checked ) {
			options = _.filter( activeOptions, n => {
				return guids.indexOf(n) === -1;
			} );
		} else {
			options = [ ...activeOptions, ...guids ]
		}

		setActiveOptions( options )
	}, [ activeOptions ] );
	
	const itemIsChecked = ( guids ) => {
		let isChecked = false;
		
		_.forEach( guids, ( guid ) => {
			if( activeOptions.indexOf( guid ) !== -1 ) {
				isChecked = true;
				return false;
			}
		})
		
		return isChecked;
	}
	
	const filteredOptions = useMemo( () => {
		if( _.size( filter ) === 0 ) {
			return options;
		}
		
		const result = [];
		_.forEach( options, ( option, option_key ) => {
			if( option?.title?.toLowerCase().indexOf( filter ) !== -1 ) {
				result.push( option );
			}
		});
		
		return result;
	}, [ options, filter ] )
	
	useEffect( () => {
		setLoading( false )
	}, [] );
	
	const footer = useMemo( () => {
		if( loading ) {
			return null;
		}
		
		return (
			<FooterBar
				buttons={[
					<Button
						style={ [ FooterStyles.button, FooterStyles.buttonFill ] }
						appearance={'ghost'}
						status={ "danger" }
						onPress={ removeActive }
						disabled={ _.size( activeOptions ) === 0 }>
						
						{ i18n.t( 'page.coworker.filters.remove_selection' ) }
					</Button>,
					<Button
						style={ [ FooterStyles.button, FooterStyles.buttonFill ] }
						onPress={ applyFilterOptions }>
						
						{ i18n.t( 'page.coworker.filters.apply' ) }
					</Button>
				]}
				onHeightCallback={ layoutRef.current?.setFooterHeight }
			/>
		)
	}, [ loading, activeOptions, applyFilterOptions, removeActive ] )
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				ref={ layoutRef }
				title={ title }
				topNavigation={ true }
				showBackButton={ true }
				footerBar={ true }
				enableScrollView={ true }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					<ThemedInputSearch
						placeholder={ i18n.t( 'ui.filter' ) }
						value={ filter }
						onChangeText={ filterChanged.bind( this ) }
						style={ styles.selectionFilter }
					/>
					
					<ThemedBlock shadow>
						<ThemedList
							style={ styles.listContainer }
							data={ filteredOptions }
							renderItem={ renderItem.bind( this ) }
							ItemSeparatorComponent={ Divider }
							scrollEnabled={ false }
						/>
					</ThemedBlock>
				</VStack>
			</ThemedLayout>
			
			{ footer }
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeCoworkerFilterSelectionScene
